import styled, { css } from "styled-components";

const panelWidth = "450px";

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-primary);
  width: 100%;
  top: auto;
  //bottom: calc(-100% + 80px);
  bottom: calc(-100%);
  transition: all 0.2s ease-out;

  h2 {
    font-family: var(--font-primary);
    font-weight: 500;
    font-size: 18px;
    color: var(--color-primary);
    margin: 0 0 10px 0;
  }

  ul {
    padding-left: 20px;
  }

  li:not(:last-child) {
    margin-bottom: 10px;
  }

  ${(props) =>
    props.isOpen === true &&
    css`
      bottom: 0;
    `}

  &:after {
    content: "";
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: calc(100% - 20px);
    height: 38px;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }

  @media (min-width: 640px) {
    ${(props) =>
      props.position === "left"
        ? css`
            left: calc((${panelWidth} + 25px) * -1);
          `
        : css`
            right: calc((${panelWidth} + 25px) * -1);
          `};

    top: 0;
    bottom: auto;
    width: ${panelWidth} !important;
    border-right: 1px solid var(--color-light-gray);

    ${(props) =>
      props.isOpen === true &&
      props.position === "left" &&
      css`
        left: 0;
      `}
      ${(props) =>
        props.isOpen === true &&
        props.position === "right" &&
        css`
          right: 0;
        `}
`;

export const ToggleButton = styled.button`
  width: 100%;
  height: 80px;
  background: var(--color-light);
  border: none;
  border-radius: 40px 40px 0 0;
  padding: 32px 50px 10px 50px;
  text-align: left;
  cursor: pointer;

  &:before {
    display: block;
    content: "";
    position: absolute;
    width: 35px;
    border-top: 3px solid var(--color-secondary);
    border-radius: 4px;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (min-width: 640px) {
    position: absolute;
    top: 40%;
    ${(props) =>
      props.position === "left"
        ? css`
            right: -25px;
          `
        : css`
            left: -25px;
          `}

    width: 25px;
    height: 50px;
    border-radius: 10px 0px 0px 10px;
    box-shadow: 0px 2px 4px #00000029;
    padding: 0;

    ${(props) =>
      props.position === "left" &&
      css`
        transform: rotate(180deg);
      `}

    &:before {
      display: block;
      content: "";
      position: absolute;
      width: auto;
      top: 50%;
      left: 5px;
      transform: translateY(-50%) rotate(270deg);
      border-radius: none;
      border-top: none;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 6px solid #358;
    }

    ${(props) =>
      props.isOpen === true &&
      css`
        &:before {
          transform: translateY(-50%) rotate(90deg);
        }
      `}
  }
`;

export const ToggleButtonLabel = styled.div`
  font-size: 20px;
  font-family: var(--font-primary);
  color: var(--color-primary);

  @media (min-width: 640px) {
    display: none;
  }
`;

export const FilterCount = styled.p`
  color: var(--color-primary);
  margin: 0;
  text-transform: uppercase;
  font-size: 18px;
  font-family: var(--font-primary);

  @media (min-width: 640px) {
    font-size: 12px;
  }
`;

export const ResultsCount = styled.p`
  color: var(--color-primary);
  font-family: var(--font-primary);
  font-size: 18px;
  margin: 0 0 20px 0;

  @media (min-width: 640px) {
    font-size: 16px;
    margin: 0 0 12px 0;
  }
`;

export const ClearAll = styled.button`
  font-size: 18px;
  font-family: var(--font-primary);
  color: var(--color-gray);
  text-transform: uppercase;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;

  @media (min-width: 640px) {
    font-size: 12px;
  }
`;

export const Header = styled.div`
  position: relative;
  flex: none;
  min-height: 130px;
  display: flex;
  align-items: center;
  ${(props) => !props.default &&
    css`
      padding: 20px;
  `}
  background: white;
  text-align: center;

  @media (min-width: 640px) {
    min-height: 120px;
    box-shadow: 0px 1px 5px #00000010;
  }
`;

export const Logo = styled.img`
  margin: 0 auto;
  max-width: 100%;
  
  ${(props) => props.default ?
    css`
      max-height: none;
    ` : css`
      max-height: 125px;
    `
  }
`;

export const Section = styled.div`
  margin-bottom: 30px;
`;

export const Facets = styled.div`
  position: relative;
  z-index: 1;
  padding: 32px 50px 32px 50px;
  overflow-y: auto;
  background: #fafafa;
  height: 100%;

  @media (min-width: 640px) {
    padding: 32px 32px 32px 32px;
  }
`;

export const FacetGroup = styled.fieldset`
  padding: 0;
  margin: 0 0 10px 0;
  border: none;

  legend {
    margin-bottom: 10px;
    padding: 0;
    text-transform: uppercase;
  }

  h3 {
    font-size: 16px;
  }

  label {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 5px;
    font-size: 16px;
  }

  input {
    margin: 0 8px 0 0;
    height: 18px;
    border-color: var(--color-primary);
  }

  @media (min-width: 640px) {
    label {
      font-size: 14px;
    }
  }
`;
